import { TrafficHub } from '@cloudmatize/traffic-hub'

export function TrafficHubPage() {
  return <TrafficHub />
}
